import styled from 'styled-components';
import React, { useMemo, useState } from 'react';
import useSWR from 'swr';

import { fetcher } from '../utils';
import WageList from './WageList';
import UnwagedList from './UnwagedList';
import Reports from './Reports';

const WageProcessor = ({ sheet_id }) => {

    const { data: months, error } = useSWR( `/api/wage-processor/months`, fetcher, {
        revalidateOnReconnect: false,
        revalidateOnFocus: false
    });

    const [ month, setMonth ] = useState(null);
    const [ tab, setTab ] = useState('waged');
    const [ batchNumber, setBatchNumber ] = useState(1);

    function updateBatchNumber() {
        setBatchNumber(p => p + 1);
    }

    const years = useMemo(() => {
        if (!months) return [];

        return months.map(month => month.split('-')[0])
            .filter((year, index, arr) => arr.indexOf(year) === index);
    }, [months])
    
    return (
        <StyledWageProcessor>
            { !month && <>
                <h2>請選擇要處理的月份</h2>
                { years.map?.(year => (
                    <div className='year-group' key={year}>
                        <h4 >{year}</h4>
                        <ul className='months'>
                            { months.filter(_month => _month.indexOf(year) >= 0).map?.( (_month, index) => (
                                <li key={index}>
                                    <button onClick={ () => setMonth(_month) }>{_month}</button>
                                </li>
                            ))}
                        </ul>
                    </div>
                ))}
            </>}

            { month && <>
                <h2>{ month } 薪資條管理</h2>
                <div className="well">
                    <div className="btn-group">
                        <button className={`btn btn-default`} onClick={() => setMonth(null)}>選擇月份</button>
                        <button className={`btn btn-default ${tab === 'unwaged' ? '-active': ''}`} onClick={() => setTab('unwaged')}>未結算</button>
                        <button className={`btn btn-default ${tab === 'waged' ? '-active': ''}`} onClick={() => setTab('waged')}>已結算</button>
                        <button className={`btn btn-default ${tab === 'reports' ? '-active': ''}`} onClick={() => setTab('reports')}>已產製的薪資單</button>
                    </div>
                </div>

                { tab === 'waged' && <WageList month={month} sheetId={sheet_id} batchNumber={batchNumber} updateBatchNumber={updateBatchNumber} /> }
                { tab === 'unwaged' && <UnwagedList month={month} sheetId={sheet_id} /> }
                { tab === 'reports' && <Reports month={month} batchNumber={batchNumber} updateBatchNumber={updateBatchNumber} /> }
            </>}
        </StyledWageProcessor>
    )
}

const StyledWageProcessor = styled.div`
    .btn-default.-active {
        color: white;
        background-color: #725A7A;
        border-color: #725A7A;
    }

    .year-group {
        width: max-content;
        margin: 0 auto;
        margin-top: 40px;

        h4 {
            font-size: 16px;
        }
    }

    .months {
        width: max-content;
        display: grid;
        grid-template-columns: repeat(6, 1fr);

        button {
            margin-top: -1px;
            margin-right: -1px;
            padding: 8px 16px;
            border-radius: 0;
            border: 1px solid #aaa;
            background-color: transparent;
        }
    }
`

export default WageProcessor